export const splitByFirstOccurrence = (
  text: string,
  character = ''
): [string, string] => {
  const data = text?.slice(0, text.indexOf(character));
  const name = text?.slice(text.indexOf(character) + 1);

  return [data, name];
};
